import React from "react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { addDays, startOfWeek, isSameDay } from "date-fns";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { useTranslation } from "react-i18next";

const WEEKDAY_KEY_BY_JS_DAY = {
  0: "plan.weekdays.sun",
  1: "plan.weekdays.mon",
  2: "plan.weekdays.tue",
  3: "plan.weekdays.wed",
  4: "plan.weekdays.thu",
  5: "plan.weekdays.fri",
  6: "plan.weekdays.sat",
};

export function Timeline({ selectedDate, onDateSelect }) {
  const [startDate, setStartDate] = React.useState(
    startOfWeek(new Date(), { weekStartsOn: 1 })
  );
  const { t } = useTranslation();

  const days = Array.from({ length: 7 }, (_, i) => addDays(startDate, i));

  const nextWeek = () => setStartDate(addDays(startDate, 7));
  const prevWeek = () => setStartDate(addDays(startDate, -7));

  return (
    <div className="flex items-center justify-between bg-card p-4 rounded-lg border shadow-sm mb-6">
      <Button variant="ghost" size="icon" onClick={prevWeek}>
        <ChevronLeft className="h-4 w-4" />
      </Button>
      
      <div className="flex flex-1 justify-around px-2 overflow-x-auto">
        {days.map((day) => {
          const isSelected = isSameDay(day, selectedDate);
          const isToday = isSameDay(day, new Date());
          const weekdayKey = WEEKDAY_KEY_BY_JS_DAY[day.getDay()];
          
          return (
            <button
              key={day.toString()}
              onClick={() => onDateSelect(day)}
              className={cn(
                "flex flex-col items-center justify-center w-12 h-16 rounded-xl transition-all",
                isSelected ? "bg-primary text-primary-foreground shadow-md scale-110" : "hover:bg-accent",
                isToday && !isSelected && "border-2 border-primary text-primary"
              )}
            >
              <span className="text-xs font-medium opacity-80">
                {t(weekdayKey)}
              </span>
              <span className="text-lg font-bold">
                {day.getDate()}
              </span>
            </button>
          );
        })}
      </div>

      <Button variant="ghost" size="icon" onClick={nextWeek}>
        <ChevronRight className="h-4 w-4" />
      </Button>
    </div>
  );
}
